import Type from "@/model/types/Type";

const type = {
    NOT_EXCLUSIVE: 90,
    CUSTOMER: 1,
    GROUP_CUSTOMER: 2,
}

const list = [
    {
        value: type.NOT_EXCLUSIVE,
        text: "Não",
    },
    {
        value: type.CUSTOMER,
        text: "Cliente",
    },
    {
        value: type.GROUP_CUSTOMER,
        text: "Grupo de Cliente",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}